import React, { useState } from 'react';
import { IconButton } from '@fluentui/react';
import { isMSSeller } from '../../../../components/shared/common/util';

const bannerContainerStyle: React.CSSProperties = {
    background: 'linear-gradient(135deg, #0078d4 0%, #005a9e 100%)',
    color: '#ffffff',
    padding: '14px 20px',
    marginBottom: '12px',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    boxShadow: '0 2px 8px rgba(0, 120, 212, 0.3)',
    border: '1px solid #005a9e',
};

const bannerIconStyle: React.CSSProperties = {
    fontSize: '22px',
    flexShrink: 0,
    marginTop: '2px',
};

const bannerTextStyle: React.CSSProperties = {
    fontSize: '14px',
    lineHeight: '1.5',
    flex: 1,
};

const bannerBadgeStyle: React.CSSProperties = {
    display: 'inline-block',
    background: '#ffd700',
    color: '#1a1a1a',
    fontWeight: 700,
    fontSize: '12px',
    padding: '2px 8px',
    borderRadius: '4px',
    marginRight: '8px',
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
};

/**
 * Temporary banner to inform users about new automated review feature.
 * This banner is displayed on deal creation/editing pages.
 */
const WhatsNewBanner: React.FunctionComponent = () => {
    const [isDismissed, setIsDismissed] = useState<boolean>(false);

    if (isDismissed || isMSSeller()) {
        return null;
    }

    return (
        <div style={bannerContainerStyle} role="alert" aria-label="What's new announcement">
            <span style={bannerIconStyle}>&#9889;</span>
            <div style={bannerTextStyle}>
                <span style={bannerBadgeStyle}>What&apos;s New</span>
                An automated review now assesses your Presales Activity, Deal Overview, and Deal Vertical for completeness on Deal Registration cases. This check is non-blocking—you can continue as normal, and you will be prompted for more detail only if needed to improve the likelihood of first-time approval.
            </div>
            <IconButton
                iconProps={{ iconName: 'Cancel' }}
                ariaLabel="Dismiss banner"
                onClick={() => setIsDismissed(true)}
                styles={{
                    root: { color: '#ffffff', height: 24, width: 24 },
                    rootHovered: { color: '#ffffff', backgroundColor: 'rgba(255,255,255,0.2)' },
                }}
            />
        </div>
    );
};

export default WhatsNewBanner;
